<div class="page-body">
    <router-outlet></router-outlet>
</div>